<template>
    <div class="passsenger_details">
        <!-- loading -->
        <div v-if="loading" class="data-loading" style="text-align: center;position: fixed;width: 100%;height: 80%;display: flex;justify-content: center;align-items: center;">
          <van-loading size="35" color="#de5d0a" />
        </div>
        <div v-else>
            <!-- One Way -->
            <div v-if="checkGoBack()">
                <div style="padding-bottom: 60px;">
                    <div class="cart_pass">
                        <div class="cntect_inf" :class="{langKh: addFontKhmer}">{{$t('message.contactInformation')}}</div>
                        <div class="from_contact">
                            <div class="row">
                                <div class="col-sm" style="position: relative;">
                                    <label :class="{langKh: addFontKhmer}">{{$t('message.labelName')}} <span>*</span></label>
                                    <input type="text" v-model="profile.fullName" @keyup="clearTextBox" class="input_name" :class="{langKh: addFontKhmer}" style="padding-left: 27px;padding-right: 9px;" :placeholder="$t('message.name')">
                                    <font-awesome-icon icon="fa-solid fa-user" style="position: absolute;top: 30px;left: 8px;color: #de5d0a;" />
                                </div>
                                <div class="col-sm" style="position: relative;">
                                    <label :class="{langKh: addFontKhmer}">{{$t('message.labelTelephone')}} <span>*</span></label>
                                    <input type="tel" v-model="profile.phone" @keyup="clearTextBox" class="input_telephone"  :class="{langKh: addFontKhmer}" :placeholder="$t('message.telephone')">
                                    <font-awesome-icon icon="fa-solid fa-phone" style="position: absolute;top: 31px;left: 8px;color: #de5d0a;" />
                                </div>
                            </div>
                            <div class="select_board">
                                <div class="col-sm-12" style="margin-top: 10px;">
                                    <label :class="{langKh: addFontKhmer}">{{$t('message.selectBoardingPoint')}}</label>
                                    <div class="custom-select" :tabindex="tabindex" @blur="open = false">
                                        <div class="selected" :class="{ open: open }" @click="open = !open">
                                        {{ limitStr(selectedBox, 33) }}
                                        </div>
                                        <div class="items" :class="{ selectHide: !open }">
                                            <div v-for="parking in parkingup" :key="parking.id" @click="storeData(pointName = parking.name, pointId= parking.id),selectedBox = parking.name; open = false; $emit('input', parking.name);">
                                                {{ parking.name }} 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="select_board" style="margin-top: 10px;">
                                <div class="col-sm-12" style="padding-top: 8px;">
                                    <label :class="{langKh: addFontKhmer}">{{$t('message.dropOffPoint')}}</label>
                                     <div class="custom-select" :tabindex="tabindex" @blur="open1 = false">
                                        <div class="selected" :class="{ open1: open1 }" @click="open1 = !open1">
                                        {{ limitStr(selectedBoxDown, 33) }}
                                        </div>
                                        <div class="items" :class="{ selectHide: !open1 }">
                                            <div v-for="parking in parkingdown" :key="parking.id" @click="storeDataDown(pointNameDown = parking.name, pointIdDown = parking.id),selectedBoxDown = parking.name; open1 = false; $emit('input', parking.name);">
                                                {{ parking.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="custo_information" :class="{langKh: addFontKhmer}">{{$t('message.customerInformation')}}</div>
                        <div class="num_seat_select_gen_na" style="padding-bottom: 13px;" v-for="(seat, index) in seatLabel" :key="seat.id">
                            <div class="num_seat" :class="{langKh: addFontKhmer}">{{$t('message.seatNumber')}} : {{seat}}</div>
                            <div v-if="selected[index] == 0">
                                <div class="InputGroup"> 
                                    <span style="display: flex;align-items: center;width: 100%;color: rgba(0, 0, 0, 0.87);" :class="{langKh: addFontKhmer}">{{$t('message.gender')}}</span>
                                    <input class="label" type="radio" name="male" id="male" value="1" />
                                    <label class="label" @click="setdestinationFrom(index, 1)" :class="{langKh: addFontKhmer}" for="male"><img :src="require('@/assets/male.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span>{{$t('message.male')}}</label>
                                    <input type="radio" name="female" id="female" value="2"  >
                                    <label class="label" @click="setdestinationFrom(index, 2)" :class="{langKh: addFontKhmer}" for="female"><img :src="require('@/assets/female.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span> {{$t('message.female')}}</label>
                                </div>
                            </div>

                            <div v-if="selected[index] != 0">
                                <div v-if="selected[index] == 1">
                                    <div class="InputGroup"> 
                                        <span style="display: flex;align-items: center;width: 100%;color: rgba(0, 0, 0, 0.87);" :class="{langKh: addFontKhmer}">{{$t('message.gender')}}</span>
                                        <input class="label" type="radio" name="male" id="male" value="1"/>
                                        <label class="labelSetColor" @click="setdestinationFrom(index, 1)" :class="{langKh: addFontKhmer}" for="male"><img :src="require('@/assets/male.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span>{{$t('message.male')}}</label>
                                        <input type="radio" name="female" id="female" value="2" />
                                        <label class="label" @click="setdestinationFrom(index, 2)" :class="{langKh: addFontKhmer}" for="female"><img :src="require('@/assets/female.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span> {{$t('message.female')}}</label>
                                    </div>
                                </div>
                                <div v-if="selected[index] == 2">
                                    <div class="InputGroup"> 
                                        <span style="display: flex;align-items: center;width: 100%;color: rgba(0, 0, 0, 0.87);" :class="{langKh: addFontKhmer}">{{$t('message.gender')}}</span>
                                        <input class="label" type="radio" name="male" id="male" value="1" />
                                        <label class="label"  @click="setdestinationFrom(index, 1)" :class="{langKh: addFontKhmer}" for="male"><img :src="require('@/assets/male.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span>{{$t('message.male')}}</label>
                                        <input type="radio" name="female" id="female" value="2"/>
                                        <label class="labelSetColor" @click="setdestinationFrom(index, 2)" :class="{langKh: addFontKhmer}" for="female"><img :src="require('@/assets/female.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span> {{$t('message.female')}}</label>
                                    </div>
                                </div>
                            </div>

                            <div v-if="selectedNation[index] == 0">
                                <div class="InputGroup" style="margin-top: 20px;"> 
                                    <span style="display: flex;align-items: center;width: 93%;color: rgba(0, 0, 0, 0.87);" :class="{langKh: addFontKhmer}">{{$t('message.national')}}</span>

                                    <input class="label" type="radio" name="enmer" id="enmer" value="enmer" />
                                    <label class="label" @click="setValueNat(index, 1)" for="enmer" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.cambodian')}}</label>

                                    <input type="radio" name="foreigners" id="foreigners" value="foreigners" />
                                    <label class="label" @click="setValueNat(index, 2)" for="foreigners" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.foreigner')}}</label>
                                </div>
                            </div>

                            <div v-if="selectedNation[index] != 0">
                                <div v-if="selectedNation[index] == 1">
                                    <div class="InputGroup" style="margin-top: 20px;"> 
                                        <span style="display: flex;align-items: center;width: 93%;color: rgba(0, 0, 0, 0.87);" class="en" :class="{langKh: addFontKhmer}">{{$t('message.national')}}</span>

                                        <input class="label" type="radio" name="enmer" id="enmer" value="enmer" />
                                        <label class="labelSetColor" @click="setValueNat(index, 1)" for="enmer" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.cambodian')}}</label>

                                        <input type="radio" name="foreigners" id="foreigners" value="foreigners" />
                                        <label class="label" @click="setValueNat(index, 2)" for="foreigners" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.foreigner')}}</label>
                                    </div>
                                </div>
                                <div v-if="selectedNation[index] == 2">
                                    <div class="InputGroup" style="margin-top: 20px;"> 
                                        <span style="display: flex;align-items: center;width: 93%;color: rgba(0, 0, 0, 0.87);" class="en" :class="{langKh: addFontKhmer}">{{$t('message.national')}}</span>

                                        <input class="label" type="radio" name="enmer" id="enmer" value="enmer" />
                                        <label class="label" @click="setValueNat(index, 1)" for="enmer" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.cambodian')}}</label>

                                        <input type="radio" name="foreigners" id="foreigners" value="foreigners" />
                                        <label class="labelSetColor en" @click="setValueNat(index, 2)" for="foreigners" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.foreigner')}}</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div>
                    <div class="btn_process" v-if="disabled" >
                        <button class="btn_disabled" :class="{langKh: addFontKhmer}">{{$t('message.processToPayment')}}</button>
                    </div>
                    <div class="btn_process" v-else @click="getAipProcessPaymentFrom()">
                        <button :class="{langKh: addFontKhmer}">{{$t('message.processToPayment')}}</button>
                    </div>
                </div>
            </div>
            <!-- End One Way -->
            <!-- Two Way -->
            <div v-if="!checkGoBack()">
                <div style="padding-bottom: 60px;">
                    <div class="cart_pass">
                        <div class="cntect_inf" :class="{langKh: addFontKhmer}">{{$t('message.contactInformation')}}</div>
                        <div class="from_contact">
                            <div class="row">
                                <div class="col-sm" style="position: relative;">
                                    <label :class="{langKh: addFontKhmer}">{{$t('message.labelName')}} <span>*</span></label>
                                    <input type="text" v-model="profile.fullName" @keyup="clearTextBox" class="input_name" :class="{langKh: addFontKhmer}" style="padding-left: 27px;padding-right: 9px;" :placeholder="$t('message.name')">
                                    <font-awesome-icon icon="fa-solid fa-user" style="position: absolute;top: 30px;left: 8px;color: #de5d0a;" />
                                </div>
                                <div class="col-sm" style="position: relative;">
                                    <label :class="{langKh: addFontKhmer}">{{$t('message.labelTelephone')}} <span>*</span></label>
                                    <input type="tel" v-model="profile.phone" @keyup="clearTextBox" class="input_telephone" :class="{langKh: addFontKhmer}" :placeholder="$t('message.telephone')">
                                    <font-awesome-icon icon="fa-solid fa-phone" style="position: absolute;top: 31px;left: 8px;color: #de5d0a;" />
                                </div>
                            </div>
                            <div class="select_board">
                                <div class="col-sm-12" style="margin-top: 10px;">
                                    <label :class="{langKh: addFontKhmer}">{{$t('message.selectBoardingPoint')}}</label>
                                    <div class="custom-select" :tabindex="tabindex" @blur="open = false">
                                        <div class="selected" :class="{ open: open }" @click="open = !open">
                                        {{ limitStr(selectedBox, 33) }}
                                        </div>
                                        <div class="items" :class="{ selectHide: !open }">
                                            <div v-for="parking in parkingup" :key="parking.id" @click="storeData(pointName = parking.name, pointId= parking.id),selectedBox = parking.name; open = false; $emit('input', parking.name);">
                                                {{ parking.name}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="select_board" style="margin-top: 10px;">
                                <div class="col-sm-12" style="padding-top: 8px;">
                                    <label :class="{langKh: addFontKhmer}">{{$t('message.dropOffPoint')}}</label>
                                    <div class="custom-select" :tabindex="tabindex" @blur="open1 = false">
                                        <div class="selected" :class="{ open1: open1 }" @click="open1 = !open1">
                                        {{ limitStr(selectedBoxDown, 33) }}
                                        </div>
                                        <div class="items" :class="{ selectHide: !open1 }">
                                            <div v-for="parking in parkingdown" :key="parking.id" @click="storeDataDown(pointNameDown = parking.name, pointIdDown = parking.id),selectedBoxDown = parking.name; open1 = false; $emit('input', parking.name);">
                                                {{ parking.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="custo_information" :class="{langKh: addFontKhmer}">{{$t('message.customerInformation')}}</div>
                        <div class="num_seat_select_gen_na" style="padding-bottom: 13px;" v-for="(seat, index) in seatLabel" :key="seat.id">
                            <div class="num_seat" :class="{langKh: addFontKhmer}">{{$t('message.seatNumber')}} : {{seat}}</div>
                            <div v-if="selected[index] == 0">
                                <div class="InputGroup"> 
                                    <span style="display: flex;align-items: center;width: 100%;color: rgba(0, 0, 0, 0.87);" :class="{langKh: addFontKhmer}">{{$t('message.gender')}}</span>
                                    <input class="label" type="radio" name="male" id="male" value="1" />
                                    <label class="label" @click="setdestinationFrom(index, 1)" :class="{langKh: addFontKhmer}" for="male"><img :src="require('@/assets/male.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span>{{$t('message.male')}}</label>
                                    <input type="radio" name="female" id="female" value="2">
                                    <label class="label" @click="setdestinationFrom(index, 2)" :class="{langKh: addFontKhmer}" for="female"><img :src="require('@/assets/female.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span> {{$t('message.female')}}</label>
                                </div>
                            </div>

                            <div v-if="selected[index] != 0">
                                <div v-if="selected[index] == 1">
                                    <div class="InputGroup"> 
                                        <span style="display: flex;align-items: center;width: 100%;color: rgba(0, 0, 0, 0.87);" :class="{langKh: addFontKhmer}">{{$t('message.gender')}}</span>
                                        <input class="label" type="radio" name="male" id="male" value="1"/>
                                        <label class="labelSetColor"  @click="setdestinationFrom(index, 1)" :class="{langKh: addFontKhmer}" for="male"><img :src="require('@/assets/male.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span>{{$t('message.male')}}</label>
                                        <input type="radio" name="female" id="female" value="2" />
                                        <label class="label" @click="setdestinationFrom(index, 2)" :class="{langKh: addFontKhmer}" for="female"><img :src="require('@/assets/female.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span> {{$t('message.female')}}</label>
                                    </div>
                                </div>
                                <div v-if="selected[index] == 2">
                                    <div class="InputGroup"> 
                                        <span style="display: flex;align-items: center;width: 100%;color: rgba(0, 0, 0, 0.87);" :class="{langKh: addFontKhmer}">{{$t('message.gender')}}</span>
                                        <input class="label" type="radio" name="male" id="male" value="1" />
                                        <label class="label"  @click="setdestinationFrom(index, 1)" :class="{langKh: addFontKhmer}" for="male"><img :src="require('@/assets/male.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span>{{$t('message.male')}}</label>
                                        <input type="radio" name="female" id="female" value="2"/>
                                        <label class="labelSetColor" @click="setdestinationFrom(index, 2)" :class="{langKh: addFontKhmer}" for="female"><img :src="require('@/assets/female.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span> {{$t('message.female')}}</label>
                                    </div>
                                    
                                </div>
                            </div>

                            <div v-if="selectedNation[index] == 0">
                                <div class="InputGroup" style="margin-top: 20px;"> 
                                    <span style="display: flex;align-items: center;width: 93%;color: rgba(0, 0, 0, 0.87);">{{$t('message.national')}}</span>

                                    <input class="label" type="radio" name="enmer" id="enmer" value="enmer" />
                                    <label class="label" @click="setValueNat(index, 1)" :class="{langKh: addFontKhmer}" for="enmer" style="justify-content: center;padding-left: 0;">{{$t('message.cambodian')}}</label>

                                    <input type="radio" name="foreigners" id="foreigners" value="foreigners" />
                                    <label class="label" @click="setValueNat(index, 2)" :class="{langKh: addFontKhmer}" for="foreigners" style="justify-content: center;padding-left: 0;">{{$t('message.foreigner')}}</label>
                                </div>
                            </div>

                            <div v-if="selectedNation[index] != 0">
                                <div v-if="selectedNation[index] == 1">
                                    <div class="InputGroup" style="margin-top: 20px;"> 
                                        <span style="display: flex;align-items: center;width: 93%;color: rgba(0, 0, 0, 0.87);" class="en" :class="{langKh: addFontKhmer}">{{$t('message.national')}}</span>

                                        <input class="label" type="radio" name="enmer" id="enmer" value="enmer" />
                                        <label class="labelSetColor" @click="setValueNat(index, 1)" :class="{langKh: addFontKhmer}" for="enmer" style="justify-content: center;padding-left: 0;">{{$t('message.cambodian')}}</label>

                                        <input type="radio" name="foreigners" id="foreigners" value="foreigners" />
                                        <label class="label" @click="setValueNat(index, 2)" :class="{langKh: addFontKhmer}" for="foreigners" style="justify-content: center;padding-left: 0;">{{$t('message.foreigner')}}</label>
                                    </div>
                                </div>
                                <div v-if="selectedNation[index] == 2">
                                    <div class="InputGroup" style="margin-top: 20px;"> 
                                        <span style="display: flex;align-items: center;width: 93%;color: rgba(0, 0, 0, 0.87);" class="en" :class="{langKh: addFontKhmer}">{{$t('message.national')}}</span>

                                        <input class="label" type="radio" name="enmer" id="enmer" value="enmer" />
                                        <label class="label" @click="setValueNat(index, 1)" :class="{langKh: addFontKhmer}" for="enmer" style="justify-content: center;padding-left: 0;">{{$t('message.cambodian')}}</label>

                                        <input type="radio" name="foreigners" id="foreigners" value="foreigners" />
                                        <label class="labelSetColor en" @click="setValueNat(index, 2)" :class="{langKh: addFontKhmer}" for="foreigners" style="justify-content: center;padding-left: 0;">{{$t('message.foreigner')}}</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="cart_pass">
                        <div class="from_contact">
                            <div class="select_board">
                                <div class="col-sm-12" style="margin-top: 10px;">
                                    <label :class="{langKh: addFontKhmer}">{{$t('message.selectBoardingPoint')}}</label>
                                    <div class="custom-select" :tabindex="tabindex" @blur="open2 = false">
                                        <div class="selected" :class="{ open2: open2 }" @click="open2 = !open2">
                                        {{ limitStr(selectedBoxBack, 33) }}
                                        </div>
                                        <div class="items" :class="{ selectHide: !open2 }">
                                            <div v-for="parking in parkingupback" :key="parking.id" @click="storeDataBack(pointNameBack = parking.name, pointIdBack= parking.id),selectedBoxBack = parking.name; open2 = false;">
                                                {{ parking.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="select_board" style="margin-top: 10px;">
                                <div class="col-sm-12" style="padding-top: 8px;">
                                    <label :class="{langKh: addFontKhmer}">{{$t('message.dropOffPoint')}}</label>
                                    <div class="custom-select" :tabindex="tabindex" @blur="open3 = false">
                                        <div class="selected" :class="{ open3: open3 }" @click="open3 = !open3">
                                            {{ limitStr(selectedBoxBackDown, 33) }}
                                        </div>
                                        <div class="items" :class="{ selectHide: !open3 }">
                                            <div v-for="parking in parkingdownback" :key="parking.id" @click="storeDataBackDown(pointNameBackDown = parking.name, pointIdBackDown= parking.id),selectedBoxBackDown = parking.name; open3 = false;">
                                                {{ parking.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="custo_information" :class="{langKh: addFontKhmer}">{{$t('message.customerInformation')}}</div>
                        <div class="num_seat_select_gen_na" style="padding-bottom: 13px;" v-for="(seat, index) in seatLabelback" :key="seat.id">
                            <div class="num_seat" :class="{langKh: addFontKhmer}">{{$t('message.seatNumber')}} : {{seat}}</div>
                            <div v-if="selectedback[index] == 0">
                                <div class="InputGroup"> 
                                    <span style="display: flex;align-items: center;width: 100%;color: rgba(0, 0, 0, 0.87);" :class="{langKh: addFontKhmer}">{{$t('message.gender')}}</span>
                                    <input class="label" type="radio" name="male" id="male" value="1" />
                                    <label class="label" @click="setdestinationFromBack(index, 1)" :class="{langKh: addFontKhmer}" for="male"><img :src="require('@/assets/male.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span>{{$t('message.male')}}</label>
                                    <input type="radio" name="female" id="female" value="2"  >
                                    <label class="label" @click="setdestinationFromBack(index, 2)" :class="{langKh: addFontKhmer}" for="female"><img :src="require('@/assets/female.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span> {{$t('message.female')}}</label>
                                </div>
                            </div>

                            <div v-if="selectedback[index] != 0">
                                <div v-if="selectedback[index] == 1">
                                    <div class="InputGroup"> 
                                        <span style="display: flex;align-items: center;width: 100%;color: rgba(0, 0, 0, 0.87);" :class="{langKh: addFontKhmer}">{{$t('message.gender')}}</span>
                                        <input class="label" type="radio" name="male" id="male" value="1"/>
                                        <label class="labelSetColor"  @click="setdestinationFromBack(index, 1)" :class="{langKh: addFontKhmer}" for="male"><img :src="require('@/assets/male.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span>{{$t('message.male')}}</label>
                                        <input type="radio" name="female" id="female" value="2" />
                                        <label class="label" @click="setdestinationFromBack(index, 2)" :class="{langKh: addFontKhmer}" for="female"><img :src="require('@/assets/female.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span> {{$t('message.female')}}</label>
                                    </div>
                                </div>
                                <div v-if="selectedback[index] == 2">
                                    <div class="InputGroup"> 
                                        <span style="display: flex;align-items: center;width: 100%;color: rgba(0, 0, 0, 0.87);" :class="{langKh: addFontKhmer}">{{$t('message.gender')}}</span>
                                        <input class="label" type="radio" name="male" id="male" value="1" />
                                        <label class="label"  @click="setdestinationFromBack(index, 1)" :class="{langKh: addFontKhmer}" for="male"><img :src="require('@/assets/male.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span>{{$t('message.male')}}</label>
                                        <input type="radio" name="female" id="female" value="2"/>
                                        <label class="labelSetColor" @click="setdestinationFromBack(index, 2)" for="female"><img :src="require('@/assets/female.svg')" style="width:16px" alt=""><span>&nbsp;&nbsp;&nbsp;</span> {{$t('message.female')}}</label>
                                    </div>
                                    
                                </div>
                            </div>

                            <div v-if="selectedNationback[index] == 0">
                                <div class="InputGroup" style="margin-top: 20px;"> 
                                    <span style="display: flex;align-items: center;width: 93%;color: rgba(0, 0, 0, 0.87);" :class="{langKh: addFontKhmer}">{{$t('message.national')}}</span>

                                    <input class="label" type="radio" name="enmer" id="enmer" value="enmer" />
                                    <label class="label" @click="setValueNatBack(index, 1)" for="enmer" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.cambodian')}}</label>

                                    <input type="radio" name="foreigners" id="foreigners" value="foreigners" />
                                    <label class="label" @click="setValueNatBack(index, 2)" for="foreigners" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.foreigner')}}</label>
                                </div>
                            </div>

                            <div v-if="selectedNationback[index] != 0">
                                <div v-if="selectedNationback[index] == 1">
                                    <div class="InputGroup" style="margin-top: 20px;"> 
                                        <span style="display: flex;align-items: center;width: 93%;color: rgba(0, 0, 0, 0.87);" class="en" :class="{langKh: addFontKhmer}">{{$t('message.national')}}</span>

                                        <input class="label" type="radio" name="enmer" id="enmer" value="enmer" />
                                        <label class="labelSetColor" @click="setValueNatBack(index, 1)" for="enmer" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.cambodian')}}</label>

                                        <input type="radio" name="foreigners" id="foreigners" value="foreigners" />
                                        <label class="label" @click="setValueNatBack(index, 2)" for="foreigners" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.foreigner')}}</label>
                                    </div>
                                </div>
                                <div v-if="selectedNationback[index] == 2">
                                    <div class="InputGroup" style="margin-top: 20px;"> 
                                        <span style="display: flex;align-items: center;width: 93%;color: rgba(0, 0, 0, 0.87);" class="en" :class="{langKh: addFontKhmer}">{{$t('message.national')}}</span>

                                        <input class="label" type="radio" name="enmer" id="enmer" value="enmer" />
                                        <label class="label" @click="setValueNatBack(index, 1)" for="enmer" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.cambodian')}}</label>

                                        <input type="radio" name="foreigners" id="foreigners" value="foreigners" />
                                        <label class="labelSetColor en" @click="setValueNatBack(index, 2)" for="foreigners" style="justify-content: center;padding-left: 0;" :class="{langKh: addFontKhmer}">{{$t('message.foreigner')}}</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
               <div>
                    <div class="btn_process" v-if="disabled" >
                        <button class="btn_disabled" :class="{langKh: addFontKhmer}">{{$t('message.processToPayment')}}</button>
                    </div>
                    <div class="btn_process" v-else @click="getAipProcessPaymentTo()">
                        <button :class="{langKh: addFontKhmer}">{{$t('message.processToPayment')}}</button>
                    </div>
                </div>
            </div>
            <!-- End Two Way -->
        </div>
        <!-- alert dialog-->
    </div>
    <!-- alert Dialog -->
    <div v-if="alertPassInfo">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.informationNotEnough')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedPassInfo" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
    <div v-if="alertSeatSelected">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.alertSeatSelected')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedModal" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
    <div v-if="alertWrong">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.alertWrong')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedModal" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.close')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
    <div v-if="checkInternet">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.msgInternet')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedcheckInternet()" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {Loading} from "vant";
import axios from 'axios';
import qs from "qs";
export default {
    components: {
        [Loading.name]: Loading,
    },
    props: {
        tabindex: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data() {
        return {
            url: localStorage.getItem("url"),
            bearer: localStorage.getItem("bearer"),
            checkInternet: false,
            addFontKhmer: false,
            loading: true,
            // One Way 
            parkingup: [],
            parkingdown: [],
            seatNum:[],
            seatLabel:[],
            selected: [],
            selectedNation: [],
            // End One Way 
            // Two Way
            parkingupback: [],
            parkingdownback: [],
            seatLabelback: [],
            seatNumBack: [],
            selectedback: [],
            selectedNationback: [],
            // End Two way 
            // get profile from native app
            profile: {
                id: "",
                firstName: localStorage.getItem('username'),
                middleName: "",
                lastName: "",
                fullName: localStorage.getItem('fullName'),
                sex: localStorage.getItem('sex'),
                dobShort: "",
                nationality: localStorage.getItem('nationality'),
                phone: localStorage.getItem('userphone'), 
                email: "",
                lang: "en", // en, kh,
            },
            userTelephone: "",
            showInternet: false,
            alertPassInfo: false,
            disabled: false,
            alertSeatSelected: false,
            alertWrong: false,
            
            selectedBoxId: "",
            selectedBox: "",
            selectedBoxIdBack: "",
            selectedBoxBack: "",
            selectedBoxIdBackDown: "",
            selectedBoxBackDown: "",

            selectedBoxDownId: "",
            selectedBoxDown: "",

            pointName: "",
            pointId: "",
            pointNameDown: "",
            pointIdDown: "",
            pointNameBack: "",
            pointIdBack: "",
            pointNameBackDown: "",
            pointIdBackDown: "",

            open: false,
            open1: false,
            open2: false,
            open3: false,

            test: "Srae Ambel (N.4 Corner N.48) Hello World"
        }
    },
    methods: {
        storeData(pointName, pointId) {
            this.pointName = pointName;
            this.pointId = pointId;
            localStorage.setItem("boardingpoint", this.pointName);
            localStorage.setItem('bPointid', this.pointId);
        },
        storeDataDown(pointNameDown, pointIdDown) {
            this.pointNameDown = pointNameDown;
            this.pointIdDown = pointIdDown;
            localStorage.setItem("dropoff", this.pointNameDown);
            localStorage.setItem('dropoffId', this.pointIdDown);
        },
        storeDataBack(pointNameBack, pointIdBack) {
            this.pointNameBack = pointNameBack;
            this.pointIdBack = pointIdBack;
            localStorage.setItem("boardingpointB", this.pointNameBack);
            localStorage.setItem('boardingpointBId', this.pointIdBack);
        },
        storeDataBackDown(pointNameBackDown, pointIdBackDown) {
            this.pointNameBackDown = pointNameBackDown;
            this.pointIdBackDown = pointIdBackDown;
            localStorage.setItem("dropoffB", this.pointNameBackDown);
            localStorage.setItem('dropoffBId', this.pointIdBackDown);
        },
        closedModal() {
            // localStorage.removeItem('seat');
            // localStorage.removeItem('seatlabel');
            // localStorage.removeItem('seatback');
            // localStorage.removeItem('seatlabelback');
            // localStorage.setItem('backSeatSh', 1);
            // this.$router.push("/choose-seat");
            this.$router.push("/Home");
        },
        clearTextBox() {
            localStorage.setItem('fullName', this.profile.fullName);
            localStorage.setItem('userphone', this.profile.phone);
            if(localStorage.getItem("fullName") == "" && localStorage.getItem("userphone") == "") {
                this.disabled = true;
            }else if(localStorage.getItem("fullName") != "" && localStorage.getItem("userphone") != ""){
                this.disabled = false;
                localStorage.setItem('fullName', this.profile.fullName);
                localStorage.setItem('userphone', this.profile.phone);
            }else {
                this.disabled = true;
            }
        },

        closedcheckInternet() {
           this.checkInternet = false;
        },

        closedPassInfo() {
            this.alertPassInfo = false;
        },

        /* ------- One Way -----*/
        getSeatNumber() {
            let size = localStorage.getItem('seatlabel');
            let seatArray = size.split(",");
            for (let i = 0; i < seatArray.length; i++) {
                if (seatArray[i] != ",") {
                    this.seatLabel.push(seatArray[i]);
                }
            }

            let sizeNum = localStorage.getItem('seat');
            let seatNumArray = sizeNum.split(",");
            for (let i = 0; i < seatNumArray.length; i++) {
                if (seatNumArray[i] != ",") {
                    this.seatNum.push(seatNumArray[i]);
                }
            }
        },

        setdestinationFrom(index, value) {
            this.selected.splice(index, 1, value);
            localStorage.setItem('gender', this.selected);
        },

        setValueNat(index, value) {
            this.selectedNation.splice(index, 1, value);
        },

        readSeatGO() {
            let gender = localStorage.getItem('seatlabel');
            let selectedArray = gender.split(",");
            let sexSelected = 1;
            if(this.profile.sex != "M"){
                sexSelected = 2;
            }
            for (let i = 0; i < selectedArray.length; i++) {
                if (selectedArray[i] != ",") {
                    this.selected.push(sexSelected);
                    localStorage.setItem('gender', this.selected);
                }
            }
            let nation = localStorage.getItem('seatlabel');
            let nationArray = nation.split(",");
            let natSelected = 1;
            if(this.profile.nationality != "KHM" && this.profile.nationality != ""){
                natSelected = 2;
            }
            if(this.profile.nationality == "") {
                natSelected = 1;
            }
            for (let i = 0; i < nationArray.length; i++) {
                if (selectedArray[i] != ",") {
                    this.selectedNation.push(natSelected);
                }
            }
        },

        async getDatePassenger(eventid) {
            const url = this.url +`boarding-point/findBySchedule/${eventid}`;
            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type":"application/x-www-form-urlencoded; charset=UTF-8",
                    "accept": "*/*",
                },
                url
            };
            axios(config).then(response => {
                if(response.status == 200){
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.parkingup = response.data.body;
                        for(let i = 0; i < this.parkingup.length; i++){
                            this.selectedBoxId = this.parkingup[0].id;
                            this.selectedBox = this.parkingup[0].name;
                        }
                        localStorage.setItem('bPointid', this.selectedBoxId);
                        localStorage.setItem("boardingpoint", this.selectedBox);
                        this.loading = false;
                    }else{
                        this.errored = true
                    }
                }
            }).catch(error => {
                console.log(error);
            })
        },

        async getDatePassengerdown(id) {
            const url = this.url +`drop-off-point/findBySchedule/${id}`;
            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type":"application/x-www-form-urlencoded; charset=UTF-8",
                    "accept": "*/*",
                },
                url
            };
            axios(config).then(response => {
                if(response.status == 200){
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.parkingdown = response.data.body;
                        for(let i = 0; i <this.parkingdown.length; i++) {
                            this.selectedBoxDownId = this.parkingdown[0].id;
                            this.selectedBoxDown = this.parkingdown[0].name;
                        }
                        localStorage.setItem('dropoffId', this.selectedBoxDownId);
                        localStorage.setItem("dropoff", this.selectedBoxDown);
                        this.loading = false;
                    }else{
                        this.errored = true
                    }
                }
            }).catch(error => {
                console.log(error);
            })
        },

        /* ------- End One Way -----*/
        checkGoBack() {
            let check = false;

            if(localStorage.getItem('dateTo') == null) {
                check = true;
            }
            return check; 
        },

        /* ------- Two Way --------*/
        getDateTo() {
            return localStorage.getItem('dateTo');
        },

        getSeatsBack() {
            let sizeLabelBack = localStorage.getItem('seatlabelback');
            let seatLabelArray = sizeLabelBack.split(",");
            for(let i = 0 ; i < seatLabelArray.length; i++) {
                if(seatLabelArray[i] != ',') {
                    this.seatLabelback.push(seatLabelArray[i]);
                }
            } 
            let seatNumBack = localStorage.getItem('seatback');
            let seatArrayNumBack = seatNumBack.split(",");
            for (let i = 0; i < seatArrayNumBack.length; i++){
                if(seatArrayNumBack[i] != ',') {
                    this.seatNumBack.push(seatArrayNumBack[i]);
                }
            }
        },

        setdestinationFromBack(index, value) { 
            this.selectedback.splice(index, 1, value);
            localStorage.setItem('genderBack', this.selectedback);
        },

        setValueNatBack(index, value) { 
            this.selectedNationback.splice(index, 1, value);
        },

        readSeatBack() {
            let genderBack = localStorage.getItem('seatlabelback');
            let selectedArrayBack = genderBack.split(",");
            let sexSelected = 1;
            if(this.profile.sex != "M"){
                sexSelected = 2;
            }
            for(let i = 0; i< selectedArrayBack.length; i++) {
                if(selectedArrayBack[i] != ',') { 
                    this.selectedback.push(sexSelected);
                    localStorage.setItem('genderBack', this.selectedback);
                }
            }
            let nationBack = localStorage.getItem('seatlabelback');
            let nationArrayBack = nationBack.split(",");
            let natSelected = 1;
            if(this.profile.nationality != "KHM" && this.profile.nationality != ""){
                natSelected = 2;
            }
            if(this.profile.nationality == "") {
                natSelected = 1;
            }
            for(let i = 0; i< nationArrayBack.length; i++) {
                if(nationArrayBack[i] != ',') {
                    this.selectedNationback.push(natSelected);
                }
            }
        },

        
        async getDatePassengerBack(eventidback) {
            const url = this.url +`boarding-point/findBySchedule/${eventidback}`;
            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type":"application/x-www-form-urlencoded; charset=UTF-8",
                    "accept": "*/*",
                },
                url
            };
            axios(config).then(response => {
                if(response.status == 200){
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.parkingupback = response.data.body;

                        for(let i = 0; i < this.parkingupback.length; i++){
                            this.selectedBoxIdBack = this.parkingupback[0].id;
                            this.selectedBoxBack = this.parkingupback[0].name;
                        }
                        localStorage.setItem("boardingpointBId", this.selectedBoxIdBack);
                        localStorage.setItem('boardingpointB', this.selectedBoxBack);

                        this.loading = false;
                    }else{
                        this.errored = true
                    }
                }
            }).catch(error => {
                console.log(error);
            })
        },

        async getDatePassengerdownBack(idback) {
            const url = this.url +`drop-off-point/findBySchedule/${idback}`;
            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type":"application/x-www-form-urlencoded; charset=UTF-8",
                    "accept": "*/*",
                },
                url
            };
            axios(config).then(response => {
                if(response.status == 200){
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.parkingdownback = response.data.body;

                        for(let i = 0; i < this.parkingdownback.length; i++){
                            this.selectedBoxIdBackDown = this.parkingdownback[0].id;
                            this.selectedBoxBackDown = this.parkingdownback[0].name;
                        }
                        localStorage.setItem("dropoffBId", this.selectedBoxIdBackDown);
                        localStorage.setItem('dropoffB', this.selectedBoxBackDown);
                       

                        this.loading = false;
                    }else{
                        this.errored = true
                    }
                }
            }).catch(error => {
                console.log(error);
            })
        },


        /* ------- End Two Way --------*/
        getGender() {
            let check = true;
            for(let i = 0; i< this.selected.length; i++) {
                if(this.selected[i] == 0){
                    check = false;
                    break;
                }
            }
            return check;
        },

        getNation() {
            let check = true;
            for(let i = 0; i < this.selectedNation.length; i++) {
                if(this.selectedNation[i] == 0) {
                    check = false;
                    break;
                }
            }
            return check;
        },

        getGenderBack() {
            let check = true;
            for(let i = 0; i< this.selectedback.length; i++) {
                if(this.selectedback[i] == 0) {
                    check = false;
                    break;
                }
            }
            return check;
        },

        getNationBack() {
            let check = true;
            for(let i = 0; i < this.selectedNationback.length; i++) {
                if(this.selectedNationback[i] == 0) {
                    check = false;
                    break;
                }
            }
            return check;
        },

        /* Process Payement */
        async getAipProcessPaymentFrom() {
           
            // boarding point
            this.boardFrom = localStorage.getItem('bPointid');
            this.boardTo = localStorage.getItem('dropoffId');
            // Jouney date
            let resultDate = [];
            let jouDate = localStorage.getItem('dateFrom');
            resultDate.push(jouDate);

            // seatGender 
            let seaGen = [];
            if(this.getGender() && this.getNation()) {
                let seatGender = localStorage.getItem('gender');
                let seatGenderArray = seatGender.split(",");
                for(let i = 0; i<seatGenderArray.length; i++) {
                    if(seatGenderArray[i] !=",") {
                        seaGen.push(seatGenderArray[i]);
                    }
                }
            }else{
                this.alertPassInfo = true;
            }

            // journeyId 
            let resultJouId = [];
            let journeyId = localStorage.getItem('journeyid');
            resultJouId.push(journeyId);

            // journeyType
            this.journeytype = localStorage.getItem('types');

            // seatJourney
            let seatJou = [];
            let seatJourney = localStorage.getItem('seat')
            let seatJourneyArray = seatJourney.split(",");
            for(let i = 0; i<seatJourneyArray.length; i++) {
                if(seatJourneyArray[i] !=",") {
                    seatJou.push(journeyId);
                }
            }

            // seatName
            let seatN = [];
            let seatName = localStorage.getItem('seat')
            let seatNameArray = seatName.split(",");
            for(let i = 0; i<seatNameArray.length; i++) {
                if(seatNameArray[i] !=",") {
                    seatN.push(this.profile.fullName);
                }
            }

            // seatNum
            let seatNu = [];
            let seatNum = localStorage.getItem('seat');
            let seatNumArray = seatNum.split(",");
            for(let i = 0; i<seatNumArray.length; i++) {
                if(seatNumArray[i] !=",") {
                    seatNu.push(seatNumArray[i]);
                }
            }

            // seatPrice
            let resultPrice = [];
            let SPrice = localStorage.getItem('seat');
            let SpriceArray = SPrice.split(",");
            for (let i = 0; i < SpriceArray.length; i++) {
                if (SpriceArray[i] != ",") {
                    resultPrice.push(localStorage.getItem('price'));
                }
            }

            let totalSeat = this.seatNum.length;
            let seatP = localStorage.getItem('price');
            let totalAmount = totalSeat * seatP;
            parseFloat(totalAmount);
            localStorage.setItem('fullName', this.profile.fullName);
            localStorage.setItem('userphone', this.profile.phone);
            localStorage.setItem('total', totalAmount);

            const data = {
                'boardingPointId':  parseInt(this.boardFrom),
                'dropOffId'      :  parseInt(this.boardTo),
                'email'          :  'minapp@gmail.com',
                'journeyDate'    :  resultDate,
                'journeyId'      :  resultJouId,
                'journeyType'    :  1,
                'nationally'     :  1,
                'seatGender'     :  seaGen,
                'seatJourney'    :  seatJou,
                'seatName'       :  seatN,
                'seatNum'        :  seatNu,
                'seatPrice'      :  resultPrice,
                'telephone'      :  this.profile.phone,
                'totalAmount'    :  totalAmount,
                'totalSeat'      :  String(totalSeat),
                'userTelephone'  :  this.userTelephone
            };
            const url = this.url +`booking/confirm`;
            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    "accept": "*/*",
                },
                data: qs.stringify(data),
                url,
            };
            this.loading = true;
            axios(config).then((response) => {
                if (response.status == 200) {
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {
                        if(response.data.body.status == 1) {
                            this.info = response.data.body;
                            this.transactionId = this.info.transactionId;
                            localStorage.setItem('transactionId', this.transactionId);
                            this.$router.push("/payment-cart");
                        }else{
                            if(response.data.body.msg == "Sorry, some seats you selected are not available."){
                                this.alertSeatSelected = true;
                            }else{
                                this.alertWrong = true;
                            }
                        }
                    }else{
                        this.alertPassInfo = true;
                        this.loading = false;
                    }
                }
            }).catch((error) => {
                this.checkInternet = true;
                console.log(error);
            });
        },

        async getAipProcessPaymentTo(){
            // boarding point & back
            this.boardFrom = localStorage.getItem('bPointid');
            this.boardTo = localStorage.getItem('dropoffId');

            this.boardFromB = localStorage.getItem('boardingpointBId')
            this.boardToB = localStorage.getItem('dropoffBId');
            
            // Jouney date & back
            let resultDate = [];
            let jouDate = localStorage.getItem('dateFrom');
            let jouDateBack = localStorage.getItem('dateTo');
            resultDate.push(jouDate);
            resultDate.push(jouDateBack);

            // seatGender & back
            let seaGen = [];
            if(this.getGender() && this.getNation() && this.getGenderBack() && this.getNationBack()) {
                let seatGender = localStorage.getItem('gender');
                let seatGenderArray = seatGender.split(",");
                for(let i = 0; i<seatGenderArray.length; i++) {
                    if(seatGenderArray[i] !=",") {
                        seaGen.push(seatGenderArray[i]);
                    }
                }
                let genderback = localStorage.getItem('genderBack')
                let genderbackArray = genderback.split(",");
                for(let i = 0; i< genderbackArray.length; i++){
                    if(genderbackArray[i] !=",") {
                        seaGen.push(genderbackArray[i]);
                    }
                }
            }else{
                this.alertPassInfo = true;
            }

            // journeyId & back
            let resultJouId = [];
            let journeyId = localStorage.getItem('journeyid');
            let journeyIdBack = localStorage.getItem('journeyidback');
            resultJouId.push(journeyId);
            resultJouId.push(journeyIdBack);

            // journeyType & back
            this.journeytype = localStorage.getItem('types');

            
            // seatJourney & back
            let seatJou = [];
            let seatJourney = localStorage.getItem('seat')
            let seatJourneyArray = seatJourney.split(",");
            for(let i = 0; i<seatJourneyArray.length; i++) {
                if(seatJourneyArray[i] !=",") {
                    seatJou.push(journeyId);
                }
            }

            let seatJourneyBacks = localStorage.getItem('seatback');
            let seatJourneyBackArray = seatJourneyBacks.split(",");
            for(let i = 0; i<seatJourneyBackArray.length; i++) {
                if(seatJourneyBackArray[i] !=",") {
                    seatJou.push(journeyIdBack);
                }
            }

            // seatName & back
            let seatN = [];
            let seatName = localStorage.getItem('seat');
            let seatNameArray = seatName.split(",");
            for(let i = 0; i<seatNameArray.length; i++) {
                if(seatNameArray[i] !=",") {
                    seatN.push(this.profile.fullName);
                }
            }

            let seatNameBack = localStorage.getItem('seatback');
            let seatNameBackArray = seatNameBack.split(",");
            for(let i = 0; i<seatNameBackArray.length; i++) {
                if(seatNameBackArray[i] !=",") {
                    seatN.push(this.profile.fullName);
                }
            }

            // seatNum & back
            let seatNu = [];
            let seatNum = localStorage.getItem('seat');
            let seatNumArray = seatNum.split(",");
            for(let i = 0; i<seatNumArray.length; i++) {
                if(seatNumArray[i] !=",") {
                    seatNu.push(seatNumArray[i]);
                }
            }

            let seatNumBack = localStorage.getItem('seatback');
            let seatNumBackArray = seatNumBack.split(",");
            for(let i = 0; i<seatNumBackArray.length; i++) {
                if(seatNumBackArray[i] !=",") {
                    seatNu.push(seatNumBackArray[i]);
                }
            }

            // seatPrice and seatPrice Back
            this.totalAmount = 0;
            let resultPrice = [];
            let SPrice = localStorage.getItem('seat');
            let SpriceArray = SPrice.split(",");
            for (let i = 0; i < SpriceArray.length; i++) {
                if (SpriceArray[i] != ",") {
                    resultPrice.push(localStorage.getItem('price'));
                    this.totalAmount += parseFloat(localStorage.getItem('price'));
                }
            }
            let priceBa = localStorage.getItem('seatback');
            let seatPriceBacks = priceBa.split(",");
            for (let i = 0; i < seatPriceBacks.length; i++) {
                if(seatPriceBacks[i] != ',') {
                    resultPrice.push(localStorage.getItem('priceback'));
                    this.totalAmount += parseFloat(localStorage.getItem('priceback'));
                }
            }
            let totalSeat = this.seatNum.length;
            let seatPrices = this.seatNumBack.length;
            let seatPriceBack = totalSeat + seatPrices;
            localStorage.setItem('fullName', this.profile.fullName);
            localStorage.setItem('userphone', this.profile.phone);
            localStorage.setItem('total', this.totalAmount);
            

            const data = {
                'boardingPointId': Array(this.boardFrom,this.boardFromB),
                'dropOffId': Array(this.boardTo, this.boardToB),
                'email': 'minapp@gmail.com',
                'telephone': this.profile.phone,
                'journeyDate': resultDate,
                'journeyId': resultJouId,
                'journeyType': 2,
                'nationally': 1,
                'seatGender': seaGen,
                'seatJourney': seatJou,
                'seatName': seatN,
                'seatNum': seatNu,
                'seatPrice': resultPrice,
                'totalAmount': parseFloat(this.totalAmount),
                'totalSeat': String(seatPriceBack),
                'userTelephone'  : this.userTelephone
            };
            const url = this.url +`booking/confirm`;

            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    "accept": "*/*",
                },
                data: qs.stringify(data),
                url,
            };
            this.loading = true;
            axios(config).then((response) => {
                if (response.status == 200) {
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {
                        if(response.data.body.status == 1) {
                            this.info = response.data.body;
                            this.transactionId = this.info.transactionId;
                            localStorage.setItem('transactionId', this.transactionId);
                            this.$router.push("/payment-cart");
                        }else{
                            if(response.data.body.msg == "Sorry, some seats you selected are not available."){
                                this.alertSeatSelected = true;
                            }else{
                                this.alertWrong = true;
                            }
                        }
                      
                    }else{
                        this.alertPassInfo = true;
                        this.loading = false;
                    }
                }
            }).catch((error) => {
                this.checkInternet = true;
                console.log(error);
            });
        },

        limitStr (string, limit) {
            let str = string;

            if (typeof str === 'string' && str.length > limit) {
                str = str.slice(0, limit) + '...';
            }
            
            return str;
        }
    },
    created() {
        this.$bridge.callHandler("setBarTitle", { title: "Passenger Details", bgColor: "#de5d0a",color: "#ffffff"});
        this.clearTextBox();
        if(this.$i18n.locale == "en") {
            this.addFontKhmer = false;
        }else {
            this.addFontKhmer = true;
        }
        if(!navigator.onLine){
            this.checkInternet = true;
        }
        setTimeout(() => {
            if(localStorage.getItem('seatlabelback') == '' || localStorage.getItem('seatlabelback') == null) {
                this.getDatePassenger(localStorage.getItem('journeyid'));
                this.getDatePassengerdown(localStorage.getItem('journeyid'));
                this.getSeatNumber(); 
                this.readSeatGO();
            }else{
                this.getDatePassenger(localStorage.getItem('journeyid'));
                this.getDatePassengerdown(localStorage.getItem('journeyid'));
                this.getDatePassengerdownBack(localStorage.getItem('journeyidback'));
                this.getDatePassengerBack(localStorage.getItem('journeyidback'));
                this.getSeatsBack();
                this.readSeatBack();
                this.getSeatNumber(); 
                this.readSeatGO();
            }
        }, 1000);
        this.userTelephone = localStorage.getItem('userphone');
    },
    mounted() {
        this.$emit("input", this.selectedBox);
        this.$emit("input", this.selectedBoxDown);
    },
}
</script>

<style>
    .passsenger_details {
        width: 100%;
    }
    .passsenger_details .cart_pass {
        margin: 15px;
        padding: 10px 12px 15px 12px;
        border-radius: 8px;
        box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    }
    .passsenger_details .cart_pass .cart_button {
        text-align: center;
        padding: 8px;
        border-radius: 8px;
        background: #de5d0a;
        color: #FFF;
        font-weight: 500;
    }
    .passsenger_details .cart_pass .des_from_to .from_to{
        margin-top: 5px;
        display: flex;
        align-items: center;
    }
    .passsenger_details .cart_pass .cntect_inf {
        margin-top: 10px;
        font-size: 18px;
        font-weight: 500;
    }
    .passsenger_details .cart_pass .from_contact {
        margin-top: 5px;
    }
    .passsenger_details .cart_pass .row {
        margin-top: 10px;
        display: flex;
    }
    .passsenger_details .cart_pass .row .col-sm {
        width: 50%;
    }
    .passsenger_details .cart_pass .row .col-sm span {
        color: #de5d0a;
    }
    .passsenger_details .cart_pass .row .col-sm .input_name{
        margin-top: 3px;
        padding-left: 30px;
        width:98%;
        height: 35px;
        border: 1px solid #de5d0a;
        border-radius: 8px;
    }
    .passsenger_details .cart_pass .row .col-sm .input_telephone{
        margin-top: 3px;
        padding-left: 30px;
        padding-right: 9px;
        width:100%;
        height: 35px;
        border: 1px solid #de5d0a;
        border-radius: 8px;
    }
    .passsenger_details .cart_pass .from_contact .select_board{
        margin-top: 5px;
    }
    .passsenger_details .cart_pass .custo_information {
        margin-top: 25px;
        font-size: 18px;
        font-weight: 500;
    }
    .passsenger_details .cart_pass .num_seat_select_gen_na .num_seat {
        margin-top: 10px;
        margin-bottom: 8px;
    }
    .btn_process {
        text-align: center;
        padding: 15px 15px 15px 15px;
        position: fixed;
        bottom: 0;
        width: 100%;
        background: #FFF;
        box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;
    }
    .btn_process button {
        text-transform: uppercase;
        border: none;
        color: #FFF;
        font-weight: 500;
        padding: 8px;
        border-radius: 8px;
        width: 100%;
        padding: 10px;
        background: #de5d0a;
    }
    .btn_process .btn_disabled{
        text-transform: uppercase;
        border: none;
        color: #FFF;
        font-weight: 500;
        padding: 8px;
        border-radius: 8px;
        width: 100%;
        padding: 10px;
        background: gray;
    }
    /* Custom Radio*/
    .InputGroup {
        display: flex;
        width: 100%;
    }
    input[type="radio"] {
        visibility: hidden; 
        height: 0; 
        width: 0; 
    }
    label.label {
        padding-left: 10px;
        width: 100%;
        cursor: pointer;
        border: 1px solid #de5d0a;
        color: rgba(0, 0, 0, 0.87);
        height: 35px;
        border-radius: 8px;
        margin-right: 20px;
        display: flex;
        align-items: center;
    }

    label.labelSetColor {
        padding-left: 10px;
        width: 100%;
        cursor: pointer;
        border: 1px solid #21a2f5;
        background: #21a2f5;
        color: #000;
        height: 35px;
        border-radius: 8px;
        margin-right: 20px;
        display: flex;
        align-items: center;
        filter: invert(100%);
        -webkit-filter: invert(100%);
    }
    label:last-of-type {
        margin-right: 0;
    }
    .custom-select {
        margin-top: 0px;
        position: relative;
        width: 100%;
        text-align: left;
        outline: none;
        height: 40px;
        line-height: 40px;
        padding-top: 5px;
    }
    .custom-select .selected {
        border-radius: 8px;
        border: 1px solid #de5d0a;
        color: #000;
        padding-left: 1em;
        cursor: pointer;
        user-select: none;
    }
    .custom-select .selected.open {
        border-radius: 8px;
    }
    .custom-select .selected:after {
        position: absolute;
        content: "";
        top: 22px;
        right: 1em;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-color: #666666 transparent transparent transparent;
    }
    .custom-select .items {
        color: #000;
        border-radius: 0px 0px 6px 6px;
        overflow: hidden;
        position: absolute;
        background-color: #FFF;
        left: 0;
        right: 0;
        z-index: 1;
        box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
    }
    .custom-select .items div {
        color: #000;
        padding-left: 1em;
        cursor: pointer;
        user-select: none;
    }
    .custom-select .items div:hover {
        background-color: red;
    }
    .selectHide {
        display: none;
    }
</style>